// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TimelineDemo.css */
compound-evolution-timeline {
  padding-right: 1em;
}
.compound-evolution-timeline .custom-marker {
  display: flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  border-radius: 50%;
  z-index: 1;
}

.compound-evolution-timeline .p-timeline-event-content,
.compound-evolution-timeline .p-timeline-event-opposite {
  line-height: 1;
  flex: 10 1;
}

.compound-evolution-timeline .customized-timeline .p-timeline-event:nth-child(even) {
  flex-direction: row !important;
}
.compound-evolution-timeline
  .customized-timeline
  .p-timeline-event:nth-child(even)
  .p-timeline-event-content {
  text-align: left !important;
}
.compound-evolution-timeline .customized-timeline .p-timeline-event-opposite {
  flex: 0 1;
}
.compound-evolution-timeline .customized-timeline .p-card {
  margin-top: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/app/common/CompoundEvolutionTimeline/CompoundEvolutionTimeline.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,UAAQ;AACV;;AAEA;EACE,8BAA8B;AAChC;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;EACE,SAAO;AACT;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* TimelineDemo.css */\ncompound-evolution-timeline {\n  padding-right: 1em;\n}\n.compound-evolution-timeline .custom-marker {\n  display: flex;\n  width: 2rem;\n  height: 2rem;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  border-radius: 50%;\n  z-index: 1;\n}\n\n.compound-evolution-timeline .p-timeline-event-content,\n.compound-evolution-timeline .p-timeline-event-opposite {\n  line-height: 1;\n  flex: 10;\n}\n\n.compound-evolution-timeline .customized-timeline .p-timeline-event:nth-child(even) {\n  flex-direction: row !important;\n}\n.compound-evolution-timeline\n  .customized-timeline\n  .p-timeline-event:nth-child(even)\n  .p-timeline-event-content {\n  text-align: left !important;\n}\n.compound-evolution-timeline .customized-timeline .p-timeline-event-opposite {\n  flex: 0;\n}\n.compound-evolution-timeline .customized-timeline .p-card {\n  margin-top: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
